import {useMutation} from '@tanstack/react-query'
import api from 'src/services/api'
import {ExportEventsReportDTO} from 'src/services/api/endpoints/ReportsEndpoint'

export default function useEventsReport() {
  const mutation = useMutation({
    mutationFn: async (data: ExportEventsReportDTO) => {
      return await api.reports.getEventsReport(data)
    },
  })

  return mutation
}
